import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import DashboardTemplate from "../../Common/DashboardTemplate";
import {CircularProgress, TablePagination} from "@material-ui/core";
import axios from 'axios';
import {ServiceLocator} from "../../../Services/ServiceLocator";
import DrawerMenuRight from "../../Common/DrawerMenuRight";
import TextField from "@material-ui/core/TextField";
import {Button} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash} from "@fortawesome/free-solid-svg-icons";
import { AuthenticationService } from "../../../Services/AuthenticationService";
import { filterPersistenceService } from "../../../Services/FilterPersistenceService";
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import Tooltip from "@material-ui/core/Tooltip";
import Zoom from "@material-ui/core/Zoom";

const styles = theme => ({
    wrapper: {
        margin: -5,
    },
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    toolbarLeft: {
        display: 'flex',
        alignItems: 'center',
    },
    toolbarRight: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
    },
});

let assemblies = [];
let subAssemblies = [];
let parts = [];

class AdminParentChild extends React.Component {
    state = {
        loading: true,
        user: {},
        users: [],
        newConnectionQuantity: 1,
        page: 0,
        rowsPerPage: 10,
        searchTerm: ''
    };

    handleChangePage = (event, newPage) => {
        this.setState({page: newPage}, () => {
            this.saveFilterSettings();
        });
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        }, () => {
            this.saveFilterSettings();
        });
    };

    constructor(props) {
        super(props);
        globalProps = props;

        const jwtToken = AuthenticationService.getInstance().getToken();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
    }

    componentDidMount() {
        this.loadSavedFilterSettings();
        this.loadData();
    }
    loadSavedFilterSettings = () => {
        const savedSettings = filterPersistenceService.loadFilterSettings('parentchild');
        if (savedSettings) {
            this.setState({
                page: savedSettings.page || 0,
                rowsPerPage: savedSettings.rowsPerPage || 10,
                searchTerm: savedSettings.searchTerm || ''
            });
        }
    }

    saveFilterSettings = () => {
        const settings = {
            page: this.state.page,
            rowsPerPage: this.state.rowsPerPage,
            searchTerm: this.state.searchTerm,
            showAdvancedInfo: this.state.showAdvancedInfo,
            showDeactivated: this.state.showDeactivated,
            showOldRevs: this.state.showOldRevs
        };
        filterPersistenceService.saveFilterSettings('parentchild', settings);
    }

    loadData = () => {
        const self = this;
        const user = AuthenticationService.getInstance().getUser();
        if (!user || !user.userPermissions || !user.userPermissions.includes('Workshop')) {
            globalProps.history.push('/login');
            return;
        }

        self.setState({loading: true});
        Promise.all([self.loadAssemblies(), self.loadSubAssemblies(), self.loadParts()]).then(() => {
            const allItems = assemblies.concat(subAssemblies);
            self.setState({
                loading: false, 
                user, 
                assembliesAndSubAssemblies: allItems, 
                permissions: user.userPermissions, 
                newConnectionFrom: '', 
                savingConnection: false
            });
            // Focus search bar after render
            setTimeout(() => {
                if (this.searchInputRef) {
                    this.searchInputRef.focus();
                }
            }, 100);
        });
    };

    loadAssemblies = () => {
        const self = this;
        const assemblyService = ServiceLocator.Instance.getAssemblyService();

        return assemblyService.getAllAssembliesExpanded().then((assembliesResult) => {
            assemblies = assembliesResult.sort(function (a, b) {
                if (a.assembly.assemblyId > b.assembly.assemblyId) return 1;
                if (b.assembly.assemblyId > a.assembly.assemblyId) return -1;
                return 0;
            });
            self.setState({assemblies});
        });
    };

    loadSubAssemblies = () => {
        const self = this;
        const assemblyService = ServiceLocator.Instance.getAssemblyService();

        return assemblyService.getAllSubAssembliesExpanded().then((subAssembliesResult) => {
            subAssemblies = subAssembliesResult.sort(function (a, b) {
                if (a.subAssembly.subAssemblyId > b.subAssembly.subAssemblyId) return 1;
                if (b.subAssembly.subAssemblyId > a.subAssembly.subAssemblyId) return -1;
                return 0;
            });
            self.setState({subAssemblies});
        });
    };

    loadParts = () => {
        const self = this;
        self.setState({loading: true});
        const partService = ServiceLocator.Instance.getPartService();

        return partService.getAllPartsExpanded().then((partsResult) => {
            parts = partsResult.sort(function (a, b) {
                if (a.part.partId > b.part.partId) return 1;
                if (b.part.partId > a.part.partId) return -1;
                return 0;
            });
            self.setState({parts});
        });
    };

    editAssembly = (assemblyExpanded, newTab) => {
        if (newTab)
            window.open(`/admin/assemblies/${assemblyExpanded.assembly ? assemblyExpanded.assembly.id : assemblyExpanded.subAssembly.id}`);
        else
            globalProps.history.push(`/admin/assemblies/${assemblyExpanded.assembly ? assemblyExpanded.assembly.id : assemblyExpanded.subAssembly.id}`);
    };

    editPart = (partExpanded, newTab) => {
        if (newTab)
            window.open(`/admin/parts/${partExpanded.part.id}`);
        else
            globalProps.history.push(`/admin/parts/${partExpanded.part.id}`);
    };

    searchAssembly = (event) => {
        const searchInput = event.target.value;
        this.setState({searchTerm: searchInput, page: 0}, () => {
            this.saveFilterSettings();
        });
    };

    shouldShowRow = (parentItem, childItem, isSubAssembly = false) => {
        if (!this.state.searchTerm) return true;
        
        const searchTerms = this.state.searchTerm.split(' ').filter(term => term.trim() !== '');
        if (searchTerms.length === 0) return true;
        
        // Safety checks
        if (!parentItem || !childItem) return false;
        
        // All search terms must match at least one field (parent OR child)
        return searchTerms.every(term => {
            const searchTerm = term.toLowerCase();
            
            // Check if parent matches (ID or description)
            const parentId = isSubAssembly ? parentItem.subAssemblyId : parentItem.assemblyId;
            const parentDescription = parentItem.description;
            const parentMatches = (parentId && parentId.toLowerCase().includes(searchTerm)) ||
                                 (parentDescription && parentDescription.toLowerCase().includes(searchTerm));
            
            // Check if child matches (ID or description)
            const childId = childItem.partId || childItem.subAssemblyId;
            const childDescription = childItem.description;
            const childMatches = (childId && childId.toLowerCase().includes(searchTerm)) ||
                              (childDescription && childDescription.toLowerCase().includes(searchTerm));
            
            // This search term must match either parent OR child
            return parentMatches || childMatches;
        });
    };

    shouldIncludeParent = (parentItem, isSubAssembly = false) => {
        if (!this.state.searchTerm) return true;
        
        const searchTerms = this.state.searchTerm.split(' ').filter(term => term.trim() !== '');
        if (searchTerms.length === 0) return true;
        
        // Safety checks
        if (!parentItem) return false;
        
        // All search terms must match the parent
        return searchTerms.every(term => {
            const searchTerm = term.toLowerCase();
            
            // Check if parent matches (ID or description)
            const parentId = isSubAssembly ? parentItem.subAssemblyId : parentItem.assemblyId;
            const parentDescription = parentItem.description;
            const parentMatches = (parentId && parentId.toLowerCase().includes(searchTerm)) ||
                                 (parentDescription && parentDescription.toLowerCase().includes(searchTerm));
            
            return parentMatches;
        });
    };

    severPartToSubAssembly = (partId, subAssemblyId) => {
        let confirm = true;
        if (subAssemblies.find(x => x.subAssembly.id === subAssemblyId) && subAssemblies.find(x => x.subAssembly.id === subAssemblyId).totalSold > 0)
            confirm = window.confirm("Editing this BOM changes records tied to sales data. You are about to alter a lot of data. Are you sure you wish to continue?");
        else
            confirm = window.confirm("Are you sure you want to sever this connection?");

        if (!confirm) return;

        const self = this;
        const partService = ServiceLocator.Instance.getPartService();
        partService.severPartToSubAssembly(partId, subAssemblyId).then(() => {
            window.$alertSuccess("Parent-child connection severed");
            self.loadData();
        });
    };

    severSubAssemblyToSubAssembly = (childSubAssemblyId, parentSubAssemblyId) => {
        let confirm = true;
        if (subAssemblies.find(x => x.subAssembly.id === parentSubAssemblyId) && subAssemblies.find(x => x.subAssembly.id === parentSubAssemblyId).totalSold > 0)
            confirm = window.confirm("Editing this BOM changes records tied to sales data. You are about to alter a lot of data. Are you sure you wish to continue?");
        else
            confirm = window.confirm("Are you sure you want to sever this connection?");

        if (!confirm) return;

        const self = this;
        const assemblyService = ServiceLocator.Instance.getAssemblyService();
        assemblyService.severSubAssemblyToSubAssembly(childSubAssemblyId, parentSubAssemblyId).then(() => {
            window.$alertSuccess("Parent-child connection severed");
            self.loadData();
        });
    };

    severPartToAssembly = (partId, assemblyId) => {
        let confirm = true;
        if (assemblies.find(x => x.assembly.id === assemblyId) && assemblies.find(x => x.assembly.id === assemblyId).totalSold > 0)
            confirm = window.confirm("Editing this BOM changes records tied to sales data. You are about to alter a lot of data. Are you sure you wish to continue?");
        else
            confirm = window.confirm("Are you sure you want to sever this connection?");

        if (!confirm) return;

        const self = this;
        const partService = ServiceLocator.Instance.getPartService();
        partService.severPartToAssembly(partId, assemblyId).then(() => {
            window.$alertSuccess("Parent-child connection severed");
            self.loadData();
        });
    };

    severSubAssemblyToAssembly = (subAssemblyId, assemblyId) => {
        let confirm = true;
        if (assemblies.find(x => x.assembly.id === assemblyId) && assemblies.find(x => x.assembly.id === assemblyId).totalSold > 0)
            confirm = window.confirm("Editing this BOM changes records tied to sales data. You are about to alter a lot of data. Are you sure you wish to continue?");
        else if (subAssemblies.find(x => x.subAssembly.id === subAssemblyId) && subAssemblies.find(x => x.subAssembly.id === subAssemblyId).totalSold > 0)
            confirm = window.confirm("Editing this BOM changes records tied to sales data. You are about to alter a lot of data. Are you sure you wish to continue?");
        else
            confirm = window.confirm("Are you sure you want to sever this connection?");

        if (!confirm) return;

        const self = this;
        const assemblyService = ServiceLocator.Instance.getAssemblyService();
        assemblyService.severSubAssemblyToAssembly(subAssemblyId, assemblyId).then(() => {
            window.$alertSuccess("Parent-child connection severed");
            self.loadData();
        });
    };

    render() {
        const {classes} = this.props;
        const self = this;
        if (this.state.loading) {
            return (
                <DashboardTemplate title="Parent Child" onSyncDatabase={this.loadData}>
                    <div className="main-dashboard-root">
                        <CircularProgress />
                    </div>
                </DashboardTemplate>
            );
        }

        let connectionFromOptions = [];
        if (this.state.connectionToType === 'assembly') {
            this.state.subAssemblies.filter(x => x.subAssembly.isActive).forEach((subAssembly) => {
                connectionFromOptions.push({title: `${subAssembly.subAssembly.subAssemblyId} rev ${subAssembly.subAssembly.revision}`, value: subAssembly.subAssembly.id});
            });
        }
        this.state.parts.filter(x => x.part.isActive).forEach((part) => {
            connectionFromOptions.push({title: `${part.part.partId} rev ${part.part.revision}`, value: part.part.id});
        });

        let connectionToOptions = [];
        this.state.subAssemblies.filter(x => x.subAssembly.isActive).forEach((subAssembly) => {
            connectionToOptions.push({title: `${subAssembly.subAssembly.subAssemblyId} rev ${subAssembly.subAssembly.revision}`, value: subAssembly.subAssembly.id});
        });
        this.state.assemblies.filter(x => x.assembly.isActive).forEach((assembly) => {
            connectionToOptions.push({title: `${assembly.assembly.assemblyId} rev ${assembly.assembly.revision}`, value: assembly.assembly.id});
        });

        let editingAssemblyBom = [];

        return (
            <DashboardTemplate title="Parent Child" onSyncDatabase={this.loadData}>
                <div className="main-dashboard-root">
                    <div className="container">
                        <div className={classes.toolbar}>
                            <div style={{position: 'relative', display: 'flex', alignItems: 'center', width: '100%'}}>
                                {/* Left: Search Bar */}
                                <div style={{flex: '1', display: 'flex', justifyContent: 'flex-start'}}>
                                    <TextField
                                        value={this.state.searchTerm}
                                        onChange={this.searchAssembly}
                                        label="Search PN or Description..."
                                        variant="outlined"
                                        style={{width: '300px'}}
                                        inputRef={ref => this.searchInputRef = ref}
                                    />
                                </div>
                                
                                {/* Center: Buttons - Absolutely centered */}
                                <div style={{position: 'absolute', left: '50%', transform: 'translateX(-50%)'}}>
                                    {/* No buttons in this component */}
                                </div>
                                
                                {/* Right: Filter toggles */}
                                <div style={{flex: '1', display: 'flex', justifyContent: 'flex-end'}}>
                                    {/* No filter toggles in this component */}
                                </div>
                            </div>
                        </div>
                        <center>
                            <TablePagination
                                rowsPerPageOptions={[10, 25, 50]}
                                colSpan={50}
                                count={(() => {
                                    const allAssemblies = this.state.assemblies;
                                    const allSubAssemblies = this.state.subAssemblies;
                                    
                                                                         const filteredAssemblies = allAssemblies.filter(assemblyExpanded => {
                                         if (!assemblyExpanded.assembly.isActive) return false;
                                         
                                         // Check if the assembly itself matches the search
                                         const assemblyMatches = this.shouldIncludeParent(assemblyExpanded.assembly, false);
                                         
                                         const hasMatchingParts = assemblyExpanded.assembly.partsToAssemblies.some(pta => {
                                             const part = this.state.parts.find(p => p.part.id === pta.partFk);
                                             if (!part || !part.part.isActive) return false;
                                             return this.shouldShowRow(assemblyExpanded.assembly, part.part, false);
                                         });
                                         
                                         const hasMatchingSubAssemblies = assemblyExpanded.assembly.subAssembliesToAssemblies.some(sta => {
                                             const subAssembly = this.state.subAssemblies.find(sa => sa.subAssembly.id === sta.subAssemblyFk);
                                             if (!subAssembly || !subAssembly.subAssembly.isActive) return false;
                                             return this.shouldShowRow(assemblyExpanded.assembly, subAssembly.subAssembly, false);
                                         });
                                         
                                         return assemblyMatches || hasMatchingParts || hasMatchingSubAssemblies;
                                     });
                                    
                                                                         const filteredSubAssemblies = allSubAssemblies.filter(subAssemblyExpanded => {
                                         if (!subAssemblyExpanded.subAssembly.isActive) return false;
                                         
                                         // Check if the subassembly itself matches the search
                                         const subAssemblyMatches = this.shouldIncludeParent(subAssemblyExpanded.subAssembly, true);
                                         
                                         const hasMatchingParts = subAssemblyExpanded.subAssembly.partsToSubAssemblies.some(pts => {
                                             const part = this.state.parts.find(p => p.part.id === pts.partFk);
                                             if (!part || !part.part.isActive) return false;
                                             return this.shouldShowRow(subAssemblyExpanded.subAssembly, part.part, true);
                                         });
                                         
                                         const hasMatchingChildSubAssemblies = subAssemblyExpanded.subAssembly.childSubAssemblies && subAssemblyExpanded.subAssembly.childSubAssemblies.some(sts => {
                                             const childSubAssembly = this.state.subAssemblies.find(csa => csa.subAssembly.id === sts.childSubAssemblyFk);
                                             if (!childSubAssembly || !childSubAssembly.subAssembly.isActive) return false;
                                             return this.shouldShowRow(subAssemblyExpanded.subAssembly, childSubAssembly.subAssembly, true);
                                         });
                                         
                                         return subAssemblyMatches || hasMatchingParts || hasMatchingChildSubAssemblies;
                                     });
                                    
                                    return filteredAssemblies.length + filteredSubAssemblies.length;
                                })()}
                                rowsPerPage={this.state.rowsPerPage}
                                page={this.state.page}
                                slotProps={{
                                    select: {
                                        'aria-label': 'rows per page',
                                    },
                                    actions: {
                                        showFirstButton: true,
                                        showLastButton: true,
                                        slots: {
                                            firstPageIcon: FirstPageIcon,
                                            lastPageIcon: LastPageIcon,
                                            nextPageIcon: ChevronRightIcon,
                                            backPageIcon: ChevronLeftIcon,
                                        },
                                    },
                                }}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                            />
                        </center>
                        <div className="parts-table-container">
                            <table className="parts-table">
                                <thead>
                                <tr className="top-sticky-header">
                                    <th colSpan={4}>Parent Assemblies</th>
                                    <th colSpan={5}>Child Parts / Subassemblies</th>
                                    <th colSpan={9}>Parent Calculations</th>
                                    <th colSpan={24}>Child Calculations</th>
                                </tr>
                                <tr className="second-sticky-header">
                                    <th style={{minWidth: 120}}>Assembly</th>
                                    <th style={{minWidth: 35}}>Rev</th>
                                    <th style={{minWidth: 20}}>FG</th>
                                    <th style={{minWidth: 500}}>Description</th>
                                    <th style={{minWidth: 60}}>Quantity</th>
                                    <th style={{minWidth: 120}}>Part Number</th>
                                    <th style={{minWidth: 35}}>Rev</th>
                                    <th style={{minWidth: 50}}>Implied Part</th>
                                    <th style={{minWidth: 500, borderRight: '1px solid #fe65ff'}}>Description</th>
                                    <th style={{minWidth: 70, border: '1px solid #fe65ff'}}>
                                        <Tooltip
                                            title="Lifetime total number assembled."
                                            placement="top" TransitionComponent={Zoom}>
                                            <span>Total Ass'd</span>
                                        </Tooltip>
                                    </th>
                                    <th style={{minWidth: 70, border: '1px solid #fe65ff'}}>
                                        <Tooltip
                                            title="Lifetime total number assembled."
                                            placement="top" TransitionComponent={Zoom}>
                                            <span>Total Ass'd w/ Rev</span>
                                        </Tooltip>
                                    </th>
                                    <th style={{minWidth: 60}}>Total To<br/>Package</th>
                                    <th style={{minWidth: 60}}>Total To<br/>Package<br/>w/ Rev</th>
                                    <th style={{minWidth: 120}}>Min Ass'd On Hand<br/>w/ Rev</th>
                                    <th style={{minWidth: 120}}>Avg Ass'd On Hand<br/>w/ Rev</th>
                                    <th style={{minWidth: 70}}>Total Ass'd<br/>On Hand</th>
                                    <th style={{minWidth: 90}}>Total Ass'd On<br/>Hand w/ Rev</th>
                                    <th style={{minWidth: 70}}>Total Sold</th>
                                    <th style={{minWidth: 70}}>Total Sold<br/>w/ Rev</th>
                                    <th style={{minWidth: 80}}>4 week<br/>Sales / wk</th>
                                    <th style={{minWidth: 115}}>4 week<br/>Sales / wk w/ Rev</th>
                                    <th style={{minWidth: 80}}>24 week<br/>Sales / wk</th>
                                    <th style={{minWidth: 115, borderRight: '1px solid #fe65ff'}}>24 week<br/>Sales / wk w/ Rev</th>
                                    <th style={{minWidth: 95, border: '1px solid #fe65ff'}}>
                                        <Tooltip
                                            title="Lifetime total number packaged into higher level assemblies."
                                            placement="top" TransitionComponent={Zoom}>
                                            <span>Total Packaged</span>
                                        </Tooltip>
                                    </th>
                                    <th style={{minWidth: 95, border: '1px solid #fe65ff'}}>
                                        <Tooltip
                                            title="Lifetime total number packaged into higher level assemblies."
                                            placement="top" TransitionComponent={Zoom}>
                                            <span>Total Packaged<br/>w/ Rev</span>
                                        </Tooltip>
                                    </th>
                                    <th style={{minWidth: 115, border: '1px solid #fe65ff'}}>
                                        <Tooltip
                                            title="Total number of children parts/subassemblies ready to be packed into parent assemblies/finished goods."
                                            placement="top" TransitionComponent={Zoom}>
                                            <span>Total Unpackaged</span>
                                        </Tooltip>
                                    </th>
                                    <th style={{minWidth: 115, border: '1px solid #fe65ff'}}>
                                        <Tooltip
                                            title="Total number of children parts/subassemblies ready to be packed into parent assemblies/finished goods."
                                            placement="top" TransitionComponent={Zoom}>
                                            <span>Total Unpackaged<br/>w/ Rev</span>
                                        </Tooltip>
                                    </th>
                                    <th style={{minWidth: 115, border: '1px solid #fe65ff'}}>
                                        <Tooltip
                                            title="Current total needed to package parent assemblies."
                                            placement="top" TransitionComponent={Zoom}>
                                            <span>Total Needed<br/>to Package<br/>w/ Rev</span>
                                        </Tooltip>
                                    </th>
                                    <th style={{minWidth: 125, border: '1px solid #fe65ff'}}>
                                        <Tooltip
                                            title="Compares total unpackaged to total needed to package. If there are sufficient on hand to fulfill packaging requirements, it reports a 0. Otherwise it reports a 1."
                                            placement="top" TransitionComponent={Zoom}>
                                            <span>Enough to Package?<br/>w/ Rev</span>
                                        </Tooltip>
                                    </th>
                                    <th style={{minWidth: 115}}>Min Needed<br/>On Hand<br/>w/ Rev</th>
                                    <th style={{minWidth: 115}}>Avg On Hand<br/>Packaged<br/>w/ Rev</th>
                                    <th style={{minWidth: 115}}>Total On Hand<br/>Packaged</th>
                                    <th style={{minWidth: 115, borderRight: '1px solid #fe65ff'}}>Total On Hand<br/>Packaged<br/>w/ Rev</th>
                                    <th style={{minWidth: 115, border: '1px solid #fe65ff'}}>
                                        <Tooltip
                                            title="The difference between the Avg On Hand Pckgd (calculated value based on the average of minimum assembled on hand and target assembled on hand) and the Total On Hand Pckgd. Basically it's telling us if there are a low number of assemblies packed, we need to consider that we are behind on packaging."
                                            placement="top" TransitionComponent={Zoom}>
                                            <span>Packaging Deficit<br/>w/ Rev</span>
                                        </Tooltip>
                                    </th>
                                    <th style={{minWidth: 70}}>Total Sold</th>
                                    <th style={{minWidth: 70}}>Total Sold<br/>w/ Rev</th>
                                    <th style={{minWidth: 80}}>4 week<br/>Sales / wk</th>
                                    <th style={{minWidth: 115}}>4 week<br/>Sales / wk w/ Rev</th>
                                    <th style={{minWidth: 80}}>24 week<br/>Sales / wk</th>
                                    <th style={{minWidth: 115}}>24 week<br/>Sales / wk w/ Rev</th>
                                    <th style={{minWidth: 70}}>Unit Cost</th>
                                    <th style={{minWidth: 100}}>Extended Cost</th>
                                </tr>
                                </thead>
                                <tbody>
                                {(() => {
                                    // Get all assemblies and subassemblies
                                    const allAssemblies = self.state.assemblies;
                                    const allSubAssemblies = self.state.subAssemblies;
                                    
                                    // Filter based on search term using shouldShowRow logic
                                     const filteredAssemblies = allAssemblies.filter(assemblyExpanded => {
                                         if (!assemblyExpanded.assembly.isActive) return false;
                                         
                                                                                   // Check if the assembly itself matches the search
                                          const assemblyMatches = self.shouldIncludeParent(assemblyExpanded.assembly, false);
                                         
                                         // Check if any child items match the search
                                         const hasMatchingParts = assemblyExpanded.assembly.partsToAssemblies.some(pta => {
                                             const part = self.state.parts.find(p => p.part.id === pta.partFk);
                                             if (!part || !part.part.isActive) return false;
                                             return self.shouldShowRow(assemblyExpanded.assembly, part.part, false);
                                         });
                                         
                                         const hasMatchingSubAssemblies = assemblyExpanded.assembly.subAssembliesToAssemblies.some(sta => {
                                             const subAssembly = self.state.subAssemblies.find(sa => sa.subAssembly.id === sta.subAssemblyFk);
                                             if (!subAssembly || !subAssembly.subAssembly.isActive) return false;
                                             return self.shouldShowRow(assemblyExpanded.assembly, subAssembly.subAssembly, false);
                                         });
                                         
                                         return assemblyMatches || hasMatchingParts || hasMatchingSubAssemblies;
                                     });
                                    
                                                                         const filteredSubAssemblies = allSubAssemblies.filter(subAssemblyExpanded => {
                                         if (!subAssemblyExpanded.subAssembly.isActive) return false;
                                         
                                                                                   // Check if the subassembly itself matches the search
                                          const subAssemblyMatches = self.shouldIncludeParent(subAssemblyExpanded.subAssembly, true);
                                         
                                         // Check if any child items match the search
                                         const hasMatchingParts = subAssemblyExpanded.subAssembly.partsToSubAssemblies.some(pts => {
                                             const part = self.state.parts.find(p => p.part.id === pts.partFk);
                                             if (!part || !part.part.isActive) return false;
                                             return self.shouldShowRow(subAssemblyExpanded.subAssembly, part.part, true);
                                         });
                                         
                                         const hasMatchingChildSubAssemblies = subAssemblyExpanded.subAssembly.childSubAssemblies && subAssemblyExpanded.subAssembly.childSubAssemblies.some(sts => {
                                             const childSubAssembly = self.state.subAssemblies.find(csa => csa.subAssembly.id === sts.childSubAssemblyFk);
                                             if (!childSubAssembly || !childSubAssembly.subAssembly.isActive) return false;
                                             return self.shouldShowRow(subAssemblyExpanded.subAssembly, childSubAssembly.subAssembly, true);
                                         });
                                         
                                         return subAssemblyMatches || hasMatchingParts || hasMatchingChildSubAssemblies;
                                     });
                                    
                                    // Combine and paginate
                                    const allFiltered = [...filteredAssemblies, ...filteredSubAssemblies];
                                    const paginatedResults = allFiltered.slice(self.state.page * self.state.rowsPerPage, self.state.page * self.state.rowsPerPage + self.state.rowsPerPage);
                                    
                                    // Separate subassemblies and assemblies
                                    const subAssembliesInPage = paginatedResults.filter(x => x.subAssembly);
                                    const assembliesInPage = paginatedResults.filter(x => x.assembly);
                                    
                                    let allRows = [];
                                    
                                    // Render subassemblies section only if there are subassemblies
                                    if (subAssembliesInPage.length > 0) {
                                        allRows.push(...subAssembliesInPage.map((assemblyExpanded) => {
                                    const assembly = assemblyExpanded.subAssembly;
                                    if (!assembly) return '';

                                    const averageSalesFourAndTwentyFour = (assemblyExpanded.fourWeekSalesPerWeekWithRev + assemblyExpanded.twentyFourWeekSalesPerWeekWithRev) / 2;
                                    let targetAssembledOnHand = 10 * averageSalesFourAndTwentyFour < 2 ? 2 : 10 * averageSalesFourAndTwentyFour;
                                    let minAssembledOnHand = 2 * averageSalesFourAndTwentyFour;
                                    let avgAssembledOnHand = (minAssembledOnHand + targetAssembledOnHand) / 2;
                                    let totalToPackage = assemblyExpanded.totalAssembledOnHand < targetAssembledOnHand ? targetAssembledOnHand - assemblyExpanded.totalAssembledOnHand : 0;

                                    // Render child subassemblies first (if any)
                                    const childSubAssemblies = assembly.childSubAssemblies || [];
                                    let childSubAssembliesHtml = childSubAssemblies.map((childSubAssemblyRelation) => {
                                        const childSubAssemblyExpanded = this.state.subAssemblies.find(x => x.subAssembly.id === childSubAssemblyRelation.childSubAssemblyFk);
                                        if (!childSubAssemblyExpanded || !childSubAssemblyExpanded.subAssembly.isActive) return '';
                                        const childSubAssembly = childSubAssemblyExpanded.subAssembly;

                                        const totalNeededToPackage = Math.ceil(totalToPackage) * childSubAssemblyRelation.quantity;
                                        let totalUnitCost = 0.00;
                                        
                                        // Calculate cost including nested subassemblies
                                        const calculateSubAssemblyCost = (subAssembly) => {
                                            let cost = 0;
                                            // Add parts cost
                                            (subAssembly.partsToSubAssemblies || []).forEach((partToSubAssembly) => {
                                                const expandedPart = this.state.parts.find(x => x.part.id === partToSubAssembly.partFk);
                                                if (expandedPart && expandedPart.part.isActive === true) {
                                                    cost += (expandedPart.cost / expandedPart.quantity) * partToSubAssembly.quantity;
                                                }
                                            });
                                            // Add child subassemblies cost
                                            if (subAssembly.childSubAssemblies) {
                                                subAssembly.childSubAssemblies
                                                    .sort((a, b) => (a.order || 0) - (b.order || 0))
                                                    .forEach((childRelation) => {
                                                    const childSubAssemblyExpanded = this.state.subAssemblies.find(x => x.subAssembly.id === childRelation.childSubAssemblyFk);
                                                    if (childSubAssemblyExpanded && childSubAssemblyExpanded.subAssembly.isActive) {
                                                        cost += calculateSubAssemblyCost(childSubAssemblyExpanded.subAssembly) * childRelation.quantity;
                                                    }
                                                });
                                            }
                                            return cost;
                                        };

                                        totalUnitCost = calculateSubAssemblyCost(childSubAssembly);

                                        if (assembly.id === this.state.newConnectionTo) {
                                            editingAssemblyBom.push(
                                                <tr>
                                                    <td className="text-left">
                                                        {this.state.permissions.includes('EditAssembliesAndParts') ?
                                                            <FontAwesomeIcon icon={faTrash} size="1x"
                                                                             style={{
                                                                                 width: 28,
                                                                                 fontSize: 18,
                                                                                 cursor: 'pointer'
                                                                             }}
                                                                             onClick={() => {
                                                                                 this.severSubAssemblyToSubAssembly(childSubAssembly.id, assembly.id)
                                                                             }}/>
                                                            : ""}
                                                    </td>
                                                    <td>{childSubAssemblyRelation.quantity}</td>
                                                    <td>{childSubAssembly.subAssemblyId} rev {childSubAssembly.revision}</td>
                                                    <td>{childSubAssembly.revision}</td>
                                                    <td className="description-ellipsis text-left">{childSubAssembly.description}</td>
                                                </tr>
                                            );
                                        }

                                        if (!this.shouldShowRow(assembly, childSubAssembly, true)) return '';

                                        return (
                                            <tr>
                                                <td className="text-left">
                                                    {this.state.permissions.includes('EditAssembliesAndParts') ?
                                                        <span style={{fontWeight: 'bold', color: 'black', cursor: 'pointer'}}
                                                              onClick={(event) => this.editAssembly(assemblyExpanded, event.ctrlKey)}>{assembly.subAssemblyId}</span>
                                                        : <span>{assembly.subAssemblyId}</span>
                                                    }
                                                </td>
                                                <td>{assembly.revision}</td>
                                                <td></td>
                                                <td className="description-ellipsis text-left">{assembly.description}</td>
                                                <td>{childSubAssemblyRelation.quantity}</td>
                                                <td className="text-left">
                                                    {this.state.permissions.includes('EditAssembliesAndParts') ?
                                                        <span style={{fontWeight: 'bold', color: 'black', cursor: 'pointer'}}
                                                              onClick={(event) => this.editAssembly(childSubAssemblyExpanded, event.ctrlKey)}>{childSubAssembly.subAssemblyId}</span>
                                                        : <span>{childSubAssembly.subAssemblyId}</span>
                                                    }
                                                </td>
                                                <td>{childSubAssembly.revision}</td>
                                                <td style={{textAlign: 'center'}}>{childSubAssemblyRelation.isImpliedPart ? '✓' : ''}</td>
                                                <td className="description-ellipsis text-left">{childSubAssembly.description}</td>
                                                <td>{assemblyExpanded.totalAssembled.toFixed(0)}</td>
                                                <td>{assemblyExpanded.totalAssembledWithRev.toFixed(0)}</td>
                                                <td>{totalNeededToPackage.toFixed(0)}</td>
                                                <td>{totalNeededToPackage.toFixed(0)}</td>
                                                <td>{minAssembledOnHand.toFixed(0)}</td>
                                                <td>{avgAssembledOnHand.toFixed(0)}</td>
                                                <td>{assemblyExpanded.totalAssembledOnHand.toFixed(0)}</td>
                                                <td>{assemblyExpanded.totalAssembledOnHandWithRev.toFixed(0)}</td>
                                                <td>{assemblyExpanded.totalSold.toFixed(0)}</td>
                                                <td>{assemblyExpanded.totalSold.toFixed(0)}</td>
                                                <td>{assemblyExpanded.fourWeekSalesPerWeek.toFixed(2)}</td>
                                                <td>{assemblyExpanded.fourWeekSalesPerWeekWithRev.toFixed(2)}</td>
                                                <td>{assemblyExpanded.twentyFourWeekSalesPerWeek.toFixed(2)}</td>
                                                <td>{assemblyExpanded.twentyFourWeekSalesPerWeekWithRev.toFixed(2)}</td>
                                                <td>{assemblyExpanded.totalAssembled * childSubAssemblyRelation.quantity}</td>
                                                <td>{assemblyExpanded.totalAssembled * childSubAssemblyRelation.quantity}</td>
                                                <td>{childSubAssemblyExpanded.totalAssembledOnHand}</td>
                                                <td>{childSubAssemblyExpanded.totalAssembledOnHandWithRev}</td>
                                                <td>{totalNeededToPackage.toFixed(0)}</td>
                                                <td>{childSubAssemblyExpanded.totalAssembledOnHand >= totalNeededToPackage ? 0 : 1}</td>
                                                <td>{(childSubAssemblyRelation && !childSubAssemblyRelation.isImpliedPart ? Math.ceil(minAssembledOnHand) * childSubAssemblyRelation.quantity : 0).toFixed(0)}</td>
                                                <td>{(Math.ceil(avgAssembledOnHand) * childSubAssemblyRelation.quantity).toFixed(0)}</td>
                                                <td>{assemblyExpanded.totalAssembled * childSubAssemblyRelation.quantity}</td>
                                                <td>{assemblyExpanded.totalAssembledOnHand * childSubAssemblyRelation.quantity}</td>
                                                <td>{(assemblyExpanded.totalAssembledOnHandWithRev * childSubAssemblyRelation.quantity) - (Math.ceil(avgAssembledOnHand) * childSubAssemblyRelation.quantity)}</td>
                                                <td>{(assemblyExpanded.totalSold * childSubAssemblyRelation.quantity).toFixed(0)}</td>
                                                <td>{(assemblyExpanded.totalSold * childSubAssemblyRelation.quantity).toFixed(0)}</td>
                                                <td>{(assemblyExpanded.fourWeekSalesPerWeek * childSubAssemblyRelation.quantity).toFixed(2)}</td>
                                                <td>{(assemblyExpanded.fourWeekSalesPerWeekWithRev * childSubAssemblyRelation.quantity).toFixed(2)}</td>
                                                <td>{(assemblyExpanded.twentyFourWeekSalesPerWeek * childSubAssemblyRelation.quantity).toFixed(2)}</td>
                                                <td>{(assemblyExpanded.twentyFourWeekSalesPerWeekWithRev * childSubAssemblyRelation.quantity).toFixed(2)}</td>
                                                <td>${totalUnitCost.toFixed(2)}</td>
                                                <td>${(totalUnitCost * childSubAssemblyRelation.quantity).toFixed(2)}</td>
                                            </tr>
                                        )
                                    }).filter(item => item !== '');

                                    const partsToAssembly = assembly.partsToSubAssemblies || [];
                                    let partsHtml = partsToAssembly.map((assemblyPart) => {
                                        const expandedPart = this.state.parts.find(x => x.part.id === assemblyPart.partFk);
                                        if (!expandedPart) return '';
                                        const part = expandedPart.part;

                                        const totalNeededToPackage = Math.ceil(totalToPackage) * assemblyPart.quantity;

                                        if (expandedPart.part.isActive === false) return '';

                                        if (assembly.id === this.state.newConnectionTo) {
                                            editingAssemblyBom.push(
                                                <tr>
                                                    <td className="text-left">
                                                        {this.state.permissions.includes('EditAssembliesAndParts') ?
                                                            <FontAwesomeIcon icon={faTrash} size="1x"
                                                                             style={{
                                                                                 width: 28,
                                                                                 fontSize: 18,
                                                                                 cursor: 'pointer'
                                                                             }}
                                                                             onClick={() => {
                                                                                 this.severPartToSubAssembly(part.id, assembly.id)
                                                                             }}/>
                                                            : ""}
                                                    </td>
                                                    <td>{assemblyPart.quantity}</td>
                                                    <td>{part.partId} rev {part.revision}</td>
                                                    <td>{part.revision}</td>
                                                    <td className="description-ellipsis text-left">{part.description}</td>
                                                </tr>
                                            );
                                        }

                                        // Filter specific rows based on search term
                                        if (!this.shouldShowRow(assembly, part, true)) return '';

                                        return (
                                            <tr>
                                                <td className="text-left">
                                                    {this.state.permissions.includes('EditAssembliesAndParts') ?
                                                        <span style={{fontWeight: 'bold', color: 'black', cursor: 'pointer'}}
                                                              onClick={(event) => this.editAssembly(assemblyExpanded, event.ctrlKey)}>{assembly.subAssemblyId}</span>
                                                        : <span>{assembly.subAssemblyId}</span>
                                                    }
                                                </td>
                                                <td>{assembly.revision}</td>
                                                <td></td>
                                                <td className="description-ellipsis text-left">{assembly.description}</td>
                                                <td>{assemblyPart.quantity}</td>
                                                <td className="text-left">
                                                    {this.state.permissions.includes('EditAssembliesAndParts') ?
                                                        <span style={{fontWeight: 'bold', color: 'black', cursor: 'pointer'}}
                                                              onClick={(event) => this.editPart(expandedPart, event.ctrlKey)}>{part.partId}</span>
                                                        : <span>{part.partId}</span>
                                                    }
                                                </td>
                                                <td>{part.revision}</td>
                                                <td>{assemblyPart.isImpliedPart ? '✓' : ''}</td>
                                                <td className="description-ellipsis text-left">{part.description}</td>
                                                <td>{assemblyExpanded.totalAssembled.toFixed(0)}</td>
                                                <td>{assemblyExpanded.totalAssembledWithRev.toFixed(0)}</td>
                                                <td>{totalToPackage.toFixed(0)}</td>
                                                <td>{totalToPackage.toFixed(0)}</td>
                                                <td>{minAssembledOnHand.toFixed(0)}</td>
                                                <td>{avgAssembledOnHand.toFixed(0)}</td>
                                                <td>{assemblyExpanded.totalAssembledOnHand.toFixed(0)}</td>
                                                <td>{assemblyExpanded.totalAssembledOnHandWithRev.toFixed(0)}</td>
                                                <td>{assemblyExpanded.totalSold.toFixed(0)}</td>
                                                <td>{assemblyExpanded.totalSold.toFixed(0)}</td>
                                                <td>{assemblyExpanded.fourWeekSalesPerWeek.toFixed(2)}</td>
                                                <td>{assemblyExpanded.fourWeekSalesPerWeekWithRev.toFixed(2)}</td>
                                                <td>{assemblyExpanded.twentyFourWeekSalesPerWeek.toFixed(2)}</td>
                                                <td>{assemblyExpanded.twentyFourWeekSalesPerWeekWithRev.toFixed(2)}</td>
                                                <td>{assemblyExpanded.totalAssembled * assemblyPart.quantity}</td>
                                                <td>{assemblyExpanded.totalAssembled * assemblyPart.quantity}</td>
                                                <td>{expandedPart.totalUnpackaged}</td>
                                                <td>{expandedPart.totalUnpackaged}</td>
                                                <td>{totalNeededToPackage.toFixed(0)}</td>
                                                <td>{expandedPart.totalUnpackaged >= totalNeededToPackage ? 0 : 1}</td>
                                                <td>{(assemblyPart && !assemblyPart.isImpliedPart ? Math.ceil(minAssembledOnHand) * assemblyPart.quantity : 0).toFixed(0)}</td>
                                                <td>{(Math.ceil(avgAssembledOnHand) * assemblyPart.quantity).toFixed(0)}</td>
                                                <td>{assemblyExpanded.totalAssembled * assemblyPart.quantity}</td>
                                                <td>{assemblyExpanded.totalAssembledOnHand * assemblyPart.quantity}</td>
                                                <td>{(assemblyExpanded.totalAssembledOnHandWithRev * assemblyPart.quantity) - (Math.ceil(avgAssembledOnHand) * assemblyPart.quantity)}</td>
                                                <td>{(assemblyExpanded.totalSold * assemblyPart.quantity).toFixed(0)}</td>
                                                <td>{(assemblyExpanded.totalSold * assemblyPart.quantity).toFixed(0)}</td>
                                                <td>{(assemblyExpanded.fourWeekSalesPerWeek * assemblyPart.quantity).toFixed(2)}</td>
                                                <td>{(assemblyExpanded.fourWeekSalesPerWeekWithRev * assemblyPart.quantity).toFixed(2)}</td>
                                                <td>{(assemblyExpanded.twentyFourWeekSalesPerWeek * assemblyPart.quantity).toFixed(2)}</td>
                                                <td>{(assemblyExpanded.twentyFourWeekSalesPerWeekWithRev * assemblyPart.quantity).toFixed(2)}</td>
                                                <td>${expandedPart ? (expandedPart.cost / expandedPart.quantity).toFixed(2) : "-"}</td>
                                                <td>${expandedPart ? ((expandedPart.cost / expandedPart.quantity) * assemblyPart.quantity).toFixed(2) : "-"}</td>
                                            </tr>
                                        )
                                    }).filter(item => item !== '');
                                    
                                    // Combine all child content
                                    let allChildContent = [];
                                    if (childSubAssembliesHtml.length > 0) allChildContent.push(...childSubAssembliesHtml);
                                    if (partsHtml.length > 0) allChildContent.push(...partsHtml);
                                    
                                    // Only add spacer if we have visible content
                                    if (allChildContent.length > 0)
                                        allChildContent.push(<tr>
                                            <td style={{height: 8}} colSpan={42}></td>
                                        </tr>);
                                    return allChildContent;
                                        }));
                                    }
                                    
                                    // Render assemblies section only if there are assemblies
                                    if (assembliesInPage.length > 0) {
                                        allRows.push(...assembliesInPage.map((assemblyExpanded) => {
                                    const assembly = assemblyExpanded.assembly;
                                    if (!assembly || !assembly.isActive) return '';

                                    let totalHtml = [];

                                    const averageSalesFourAndTwentyFour = (assemblyExpanded.fourWeekSalesPerWeekWithRev + assemblyExpanded.twentyFourWeekSalesPerWeekWithRev) / 2;
                                    let targetAssembledOnHand = 10 * averageSalesFourAndTwentyFour < 2 ? 2 : 10 * averageSalesFourAndTwentyFour;
                                    let minAssembledOnHand = 2 * averageSalesFourAndTwentyFour;
                                    let avgAssembledOnHand = (minAssembledOnHand + targetAssembledOnHand) / 2;
                                    let totalToPackage = assemblyExpanded.totalAssembledOnHand < targetAssembledOnHand ? targetAssembledOnHand - assemblyExpanded.totalAssembledOnHand : 0;

                                    let subAssembliesHtml = (assembly.subAssembliesToAssemblies || []).map((subAssemblyToAssembly) => {
                                        const subAssemblyExpanded = this.state.subAssemblies.find(x => x.subAssembly.id === subAssemblyToAssembly.subAssemblyFk);
                                        if (!subAssemblyExpanded || !subAssemblyExpanded.subAssembly.isActive) return '';
                                        const subAssembly = subAssemblyExpanded.subAssembly;

                                        const totalNeededToPackage = Math.ceil(totalToPackage) * subAssemblyToAssembly.quantity;
                                        let totalUnitCost = 0.00;
                                        
                                        // Calculate cost including nested subassemblies
                                        const calculateSubAssemblyCost = (subAssembly) => {
                                            let cost = 0;
                                            // Add parts cost
                                            subAssembly.partsToSubAssemblies.forEach((partToSubAssembly) => {
                                                const expandedPart = this.state.parts.find(x => x.part.id === partToSubAssembly.partFk);
                                                if (expandedPart && expandedPart.part.isActive === true) {
                                                    cost += (expandedPart.cost / expandedPart.quantity) * partToSubAssembly.quantity;
                                                }
                                            });
                                            // Add child subassemblies cost
                                            if (subAssembly.childSubAssemblies) {
                                                subAssembly.childSubAssemblies
                                                    .sort((a, b) => (a.order || 0) - (b.order || 0))
                                                    .forEach((childRelation) => {
                                                    const childSubAssemblyExpanded = this.state.subAssemblies.find(x => x.subAssembly.id === childRelation.childSubAssemblyFk);
                                                    if (childSubAssemblyExpanded && childSubAssemblyExpanded.subAssembly.isActive) {
                                                        cost += calculateSubAssemblyCost(childSubAssemblyExpanded.subAssembly) * childRelation.quantity;
                                                    }
                                                });
                                            }
                                            return cost;
                                        };

                                        totalUnitCost = calculateSubAssemblyCost(subAssembly);

                                        if (assembly.id === this.state.newConnectionTo) {
                                            editingAssemblyBom.push(
                                                <tr>
                                                    <td className="text-left">
                                                        {this.state.permissions.includes('EditAssembliesAndParts') ?
                                                            <FontAwesomeIcon icon={faTrash} size="1x"
                                                                             style={{
                                                                                 width: 28,
                                                                                 fontSize: 18,
                                                                                 cursor: 'pointer'
                                                                             }}
                                                                             onClick={() => {
                                                                                 this.severSubAssemblyToAssembly(subAssembly.id, assembly.id)
                                                                             }}/>
                                                            : ""}
                                                    </td>
                                                    <td>{subAssemblyToAssembly.quantity}</td>
                                                    <td>{subAssembly.subAssemblyId}</td>
                                                    <td>{subAssembly.revision}</td>
                                                    <td className="description-ellipsis text-left">{subAssembly.description}</td>
                                                </tr>
                                            );
                                        }

                                        // Filter specific rows based on search term
                                        if (!this.shouldShowRow(assembly, subAssembly, false)) return '';

                                        return (
                                            <tr>
                                                <td className="text-left">
                                                    {this.state.permissions.includes('EditAssembliesAndParts') ?
                                                        <span style={{fontWeight: 'bold', color: 'black', cursor: 'pointer'}}
                                                              onClick={(event) => this.editAssembly(assemblyExpanded, event.ctrlKey)}>{assembly.assemblyId}</span>
                                                        : <span>{assembly.assemblyId}</span>
                                                    }
                                                </td>
                                                <td>{assembly.revision}</td>
                                                <td>x</td>
                                                <td className="description-ellipsis text-left">{assembly.description}</td>
                                                <td>{subAssemblyToAssembly.quantity}</td>
                                                <td className="text-left">
                                                    {this.state.permissions.includes('EditAssembliesAndParts') ?
                                                        <span style={{fontWeight: 'bold', color: 'black', cursor: 'pointer'}}
                                                              onClick={(event) => this.editAssembly(subAssemblyExpanded, event.ctrlKey)}>{subAssembly.subAssemblyId}</span>
                                                        : <span>{subAssembly.subAssemblyId}</span>
                                                    }
                                                </td>
                                                <td>{subAssembly.revision}</td>
                                                <td>{subAssemblyToAssembly.isImpliedPart ? '✓' : ''}</td>
                                                <td className="description-ellipsis text-left">{subAssembly.description}</td>
                                                <td>{assemblyExpanded.totalAssembled.toFixed(0)}</td>
                                                <td>{assemblyExpanded.totalAssembledWithRev.toFixed(0)}</td>
                                                <td>{totalToPackage.toFixed(0)}</td>
                                                <td>{totalToPackage.toFixed(0)}</td>
                                                <td>{minAssembledOnHand.toFixed(0)}</td>
                                                <td>{avgAssembledOnHand.toFixed(0)}</td>
                                                <td>{assemblyExpanded.totalAssembledOnHand.toFixed(0)}</td>
                                                <td>{assemblyExpanded.totalAssembledOnHandWithRev.toFixed(0)}</td>
                                                <td>{assemblyExpanded.totalSold.toFixed(0)}</td>
                                                <td>{assemblyExpanded.totalSold.toFixed(0)}</td>
                                                <td>{assemblyExpanded.fourWeekSalesPerWeek.toFixed(2)}</td>
                                                <td>{assemblyExpanded.fourWeekSalesPerWeekWithRev.toFixed(2)}</td>
                                                <td>{assemblyExpanded.twentyFourWeekSalesPerWeek.toFixed(2)}</td>
                                                <td>{assemblyExpanded.twentyFourWeekSalesPerWeekWithRev.toFixed(2)}</td>
                                                <td>{assemblyExpanded.totalAssembled * subAssemblyToAssembly.quantity}</td>
                                                <td>{assemblyExpanded.totalAssembled * subAssemblyToAssembly.quantity}</td>
                                                <td>{subAssemblyExpanded.totalAssembledOnHand}</td>
                                                <td>{subAssemblyExpanded.totalAssembledOnHand}</td>
                                                <td>{totalNeededToPackage.toFixed(0)}</td>
                                                <td>{subAssemblyExpanded.totalAssembledOnHand >= totalNeededToPackage ? 0 : 1}</td>
                                                <td>{(subAssemblyToAssembly && !subAssemblyToAssembly.isImpliedPart ? Math.ceil(minAssembledOnHand) * subAssemblyToAssembly.quantity : 0).toFixed(0)}</td>
                                                <td>{(Math.ceil(avgAssembledOnHand) * subAssemblyToAssembly.quantity).toFixed(0)}</td>
                                                <td>{assemblyExpanded.totalAssembled * subAssemblyToAssembly.quantity}</td>
                                                <td>{assemblyExpanded.totalAssembledOnHand * subAssemblyToAssembly.quantity}</td>
                                                <td>{(assemblyExpanded.totalAssembledOnHandWithRev * subAssemblyToAssembly.quantity) - (Math.ceil(avgAssembledOnHand) * subAssemblyToAssembly.quantity)}</td>
                                                <td>{(assemblyExpanded.totalSold * subAssemblyToAssembly.quantity).toFixed(0)}</td>
                                                <td>{(assemblyExpanded.totalSold * subAssemblyToAssembly.quantity).toFixed(0)}</td>
                                                <td>{(assemblyExpanded.fourWeekSalesPerWeek * subAssemblyToAssembly.quantity).toFixed(2)}</td>
                                                <td>{(assemblyExpanded.fourWeekSalesPerWeekWithRev * subAssemblyToAssembly.quantity).toFixed(2)}</td>
                                                <td>{(assemblyExpanded.twentyFourWeekSalesPerWeek * subAssemblyToAssembly.quantity).toFixed(2)}</td>
                                                <td>{(assemblyExpanded.twentyFourWeekSalesPerWeekWithRev * subAssemblyToAssembly.quantity).toFixed(2)}</td>
                                                <td>${totalUnitCost.toFixed(2)}</td>
                                                <td>${(totalUnitCost * subAssemblyToAssembly.quantity).toFixed(2)}</td>
                                            </tr>
                                        )
                                    }).filter(item => item !== '');

                                    const partsToAssembly = assembly.partsToAssemblies || [];
                                    let partsHtml = partsToAssembly.map((assemblyPart) => {
                                        const expandedPart = this.state.parts.find(x => x.part.id === assemblyPart.partFk);
                                        if (!expandedPart || !expandedPart.part.isActive) return '';
                                        const part = expandedPart.part;

                                        if (assembly.id === this.state.newConnectionTo) {
                                            editingAssemblyBom.push(
                                                <tr>
                                                    <td>
                                                        {this.state.permissions.includes('EditAssembliesAndParts') ?
                                                            <FontAwesomeIcon icon={faTrash} size="1x"
                                                                             style={{
                                                                                 width: 28,
                                                                                 fontSize: 18,
                                                                                 cursor: 'pointer'
                                                                             }}
                                                                             onClick={() => {
                                                                                 this.severPartToAssembly(part.id, assembly.id)
                                                                             }}/>
                                                            : ""}
                                                    </td>
                                                    <td>{assemblyPart.quantity}</td>
                                                    <td>{part.partId} rev {part.revision}</td>
                                                    <td>{part.revision}</td>
                                                    <td className="description-ellipsis text-left">{part.description}</td>
                                                </tr>
                                            );
                                        }

                                        // Filter specific rows based on search term
                                        if (!this.shouldShowRow(assembly, part, false)) return '';

                                        const totalNeededToPackage = Math.ceil(totalToPackage) * assemblyPart.quantity;
                                        return (
                                            <tr>
                                                <td className="text-left">
                                                    {this.state.permissions.includes('EditAssembliesAndParts') ?
                                                        <span style={{fontWeight: 'bold', color: 'black', cursor: 'pointer'}}
                                                              onClick={(event) => this.editAssembly(assemblyExpanded, event.ctrlKey)}>{assembly.assemblyId}</span>
                                                        : <span>{assembly.assemblyId}</span>
                                                    }
                                                </td>
                                                <td>{assembly.revision}</td>
                                                <td>x</td>
                                                <td className="description-ellipsis text-left">{assembly.description}</td>
                                                <td>{assemblyPart.quantity}</td>
                                                <td className="text-left">
                                                    {this.state.permissions.includes('EditAssembliesAndParts') ?
                                                        <span style={{fontWeight: 'bold', color: 'black', cursor: 'pointer'}}
                                                              onClick={(event) => this.editPart(expandedPart, event.ctrlKey)}>{part.partId}</span>
                                                        : <span>{part.partId}</span>
                                                    }
                                                </td>
                                                <td>{part.revision}</td>
                                                <td>{assemblyPart.isImpliedPart ? '✓' : ''}</td>
                                                <td className="description-ellipsis text-left">{part.description}</td>
                                                <td>{assemblyExpanded.totalAssembled.toFixed(0)}</td>
                                                <td>{assemblyExpanded.totalAssembledWithRev.toFixed(0)}</td>
                                                <td>{totalToPackage.toFixed(0)}</td>
                                                <td>{totalToPackage.toFixed(0)}</td>
                                                <td>{minAssembledOnHand.toFixed(0)}</td>
                                                <td>{avgAssembledOnHand.toFixed(0)}</td>
                                                <td>{assemblyExpanded.totalAssembledOnHand.toFixed(0)}</td>
                                                <td>{assemblyExpanded.totalAssembledOnHandWithRev.toFixed(0)}</td>
                                                <td>{assemblyExpanded.totalSold.toFixed(0)}</td>
                                                <td>{assemblyExpanded.totalSold.toFixed(0)}</td>
                                                <td>{assemblyExpanded.fourWeekSalesPerWeek.toFixed(2)}</td>
                                                <td>{assemblyExpanded.fourWeekSalesPerWeekWithRev.toFixed(2)}</td>
                                                <td>{assemblyExpanded.twentyFourWeekSalesPerWeek.toFixed(2)}</td>
                                                <td>{assemblyExpanded.twentyFourWeekSalesPerWeekWithRev.toFixed(2)}</td>
                                                <td>{assemblyExpanded.totalAssembled * assemblyPart.quantity}</td>
                                                <td>{assemblyExpanded.totalAssembled * assemblyPart.quantity}</td>
                                                <td>{expandedPart.totalUnpackaged}</td>
                                                <td>{expandedPart.totalUnpackaged}</td>
                                                <td>{totalNeededToPackage.toFixed(0)}</td>
                                                <td>{expandedPart.totalUnpackaged >= totalNeededToPackage ? 0 : 1}</td>
                                                <td>{(assemblyPart && !assemblyPart.isImpliedPart ? Math.ceil(minAssembledOnHand) * assemblyPart.quantity : 0).toFixed(0)}</td>
                                                <td>{(Math.ceil(avgAssembledOnHand) * assemblyPart.quantity).toFixed(0)}</td>
                                                <td>{assemblyExpanded.totalAssembled * assemblyPart.quantity}</td>
                                                <td>{assemblyExpanded.totalAssembledOnHand * assemblyPart.quantity}</td>
                                                <td>{(assemblyExpanded.totalAssembledOnHandWithRev * assemblyPart.quantity) - (Math.ceil(avgAssembledOnHand) * assemblyPart.quantity)}</td>
                                                <td>{(assemblyExpanded.totalSold * assemblyPart.quantity).toFixed(0)}</td>
                                                <td>{(assemblyExpanded.totalSold * assemblyPart.quantity).toFixed(0)}</td>
                                                <td>{(assemblyExpanded.fourWeekSalesPerWeek * assemblyPart.quantity).toFixed(2)}</td>
                                                <td>{(assemblyExpanded.fourWeekSalesPerWeekWithRev * assemblyPart.quantity).toFixed(2)}</td>
                                                <td>{(assemblyExpanded.twentyFourWeekSalesPerWeek * assemblyPart.quantity).toFixed(2)}</td>
                                                <td>{(assemblyExpanded.twentyFourWeekSalesPerWeekWithRev * assemblyPart.quantity).toFixed(2)}</td>
                                                <td>${expandedPart ? (expandedPart.cost / expandedPart.quantity).toFixed(2) : "-"}</td>
                                                <td>${expandedPart ? ((expandedPart.cost / expandedPart.quantity) * assemblyPart.quantity).toFixed(2) : "-"}</td>
                                            </tr>
                                        )
                                    }).filter(item => item !== '');
                                    
                                    // Only add spacer if we have visible content
                                    if ((subAssembliesHtml.length > 0 || partsHtml.length > 0))
                                        totalHtml.push(<tr>
                                            <td style={{height: 8}} colSpan={42}></td>
                                        </tr>);

                                    if (subAssembliesHtml.length > 0) totalHtml.push(...subAssembliesHtml);
                                    if (partsHtml.length > 0) totalHtml.push(...partsHtml);
                                    return totalHtml;
                                        }));
                                    }
                                    
                                    return allRows;
                                })()}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </DashboardTemplate>
        );
    }
}

let globalProps;

AdminParentChild.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AdminParentChild);
